var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.244 1.437L5.593 6.83a.572.572 0 00.814 0l5.349-5.393a.847.847 0 000-1.19.83.83 0 00-1.18 0L6 4.86 1.425.246a.831.831 0 00-1.18 0 .847.847 0 000 1.19z",
    fill: "#70777E"
  })));
}

export default SvgCheckWhite;